export default {
  FOOTER: {
    livechat: {
      text: 'btn_chat_now',
      icon: 'chat',
      isOpen: true,
      rule: 'app_version>=2.9.1&&is_login=yes',
    },
    tel: {
      url: 'tel:+65 6995 8688',
      text: 'btn_call_now',
      icon: 'call',
      isOpen: true,
    },
    email: {
      url: 'mailto:contact@cs.maribank.com.sg',
      text: 'btn_email',
      icon: 'email',
      isOpen: true,
    },
    face: {
      text: 'btn_facial_verification',
      icon: 'face',
      isDeepLink: true,
      isOpen: true,
    },
  },
};
